import React, {useState, useRef, useEffect} from 'react'
import AnalysisScatterGraph from '../graph/AnalysisScatterGraph';
import AnalysisBarGraph from '../graph/AnalysisBarGraph';
import AnalysisLineGraph from '../graph/AnalysisLineGraph';
import AnalysisMarketLineGraph from '../graph/AnalysisMarketLineGraph';
import NotebookIcon from '../NotebookIcon';
import Loading from '../Loading';


const AnalysisGraphArea = ({ selectedCompanies, selectedItem, selectedAccounts, graphData, scatterGraphData, handleBookmarkClick, width }) => {
    if (selectedCompanies.length > 0) {
        if (selectedItem==='line' && selectedAccounts.length === 0) {
            return <div id="graph-message" className='mt-2'>{"線グラフを作成します。上のボックスから項目を選択してください。"}</div>  
        } else if (selectedItem==='bar' && selectedAccounts.length === 0) {
                return <div id="graph-message" className='mt-2'>{"棒グラフを作成します。上のボックスから項目を選択してください。"}</div>  
        } else if (selectedItem === 'scatter' && selectedAccounts.length === 0) {
            return <div id="graph-message" className='mt-2'>{"散布図を作成します。上のボックスから横軸と縦軸の項目を選択してください。"}</div>  
        } else if (selectedItem === 'scatter' && selectedAccounts.length === 1) {
            return <div id="graph-message" className='mt-2'>{"散布図を作成します。上のボックスから縦軸の項目を選択してください。"}</div>  
        } 
    } else {
        return <div id="graph-message" className='mt-2'>{"左の検索画面から企業を選択してください。"}</div>  
    }
    
    if ((selectedItem !== 'scatter' && !graphData) || (selectedItem === 'scatter' && !scatterGraphData)) {
        return <Loading />
    }

    if (selectedItem === 'scatter' && scatterGraphData.length > 0) {
        return (
            <div className="graph-container-modal">
                <div className="graph-output-area">
                    <div className='analysis-title-area flex mb-4 gap-2 items-center'>
                        <div className='graph-title'>
                            <h2>{scatterGraphData[0].name[0]}と{scatterGraphData[0].name[1]}の散布図</h2>
                        </div>
                        <div className="analysis-menu-bar" >
                            <NotebookIcon chatHistoryId={0} onClick={handleBookmarkClick} />
                        </div>
                    </div>
                    <AnalysisScatterGraph
                        data={scatterGraphData[0]}
                        companies={selectedCompanies}
                    />
                </div>
            </div>
        )
    } else if (graphData.length > 0) {
        return (
            <div className="graph-container-modal" >
                <div className="graph-output-area" >
                    {graphData.map((data, index) => (
                        <div key={data.name} className="graph-section">
                            {selectedItem === 'bar' &&  (
                                (data.dataCategory === 'financial') ?
                                    <AnalysisBarGraph
                                        chatHistoryId={index}
                                        handleBookmarkClick={handleBookmarkClick}
                                        data={data}
                                        companies={selectedCompanies}
                                        parentWidth={width}
                                    />
                                :
                                <div className='py-2'>
                                    {data.name}は棒グラフでは表示できません。線グラフを選択してください。
                                </div>
                            )}
                            {selectedItem === 'line' && (
                                (data.dataCategory === 'financial') ?
                                    <AnalysisLineGraph
                                        chatHistoryId={index}
                                        handleBookmarkClick={handleBookmarkClick}
                                        data={data}
                                        companies={selectedCompanies}
                                        parentWidth={width}
                                    />
                                    :
                                    <AnalysisMarketLineGraph
                                        chatHistoryId={index}
                                        handleBookmarkClick={handleBookmarkClick}
                                        data={data}
                                        companies={selectedCompanies}
                                    />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        );
    };
}

export default AnalysisGraphArea